/* Sticky Add to Cart, the Desenio way.

   There is no second button and nothing ever appears or fades. The real Add to
   Cart is held against the bottom of the screen while its own place in the page
   is out of view, and released into that place the moment you scroll to it. The
   hand-off happens at the exact scroll position where the two coincide, so the
   button does not move at all as it docks or undocks: it is one button that
   stops.

   Implemented in script rather than `position: sticky` because sticky can only
   travel inside its parent's box, which here is the buy column. The button has
   to stay with you down the whole page, so it is fixed while docked and a
   placeholder holds its place in the flow.

   Mobile only: on desktop the buy column already sits beside the image. */
(function () {
  'use strict';
  if (window.__kvpStickyAtc) return;
  window.__kvpStickyAtc = true;

  var MOBILE = '(max-width: 749px)';
  /* iPhone screens have rounded corners, and at 12px the button's bottom left
     and bottom right were being clipped by them. This clears the curve; the
     safe-area inset below is separate and handles the home indicator. */
  var GAP = 24;          /* resting distance from the bottom edge */

  var CSS = [
    '@media screen and ' + MOBILE + '{',
    '.kvp-atc-docked{position:fixed !important;z-index:4 !important;margin:0 !important;',
    'box-shadow:0 10px 28px rgba(17,17,17,.22) !important;}',
    /* Coming down the page the dock line IS the resting line, so the button
       does not move and must not animate. Only the case where you have already
       scrolled past it is a real jump, and that one fades in. It fades rather
       than slides: a 10px slide put the button one frame out of place at the
       moment it re-docks, which reads as a hop. */
    '.kvp-atc-docked.kvp-atc-return{animation:kvpAtcIn .2s cubic-bezier(.25,.8,.25,1);}',
    '@keyframes kvpAtcIn{from{opacity:0;}to{opacity:1;}}',
    '}'
  ].join('');

  function init() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var real = form && form.querySelector('button[type=submit], [name="add"]');
    if (!real) return;

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    /* Holds the button's place in the flow while it is docked, so nothing
       below it shifts up and the release point never moves. */
    var slot = document.createElement('div');
    slot.setAttribute('aria-hidden', 'true');
    slot.style.display = 'none';
    real.parentNode.insertBefore(slot, real);

    var docked = false;

    function undock() {
      if (!docked) return;
      docked = false;
      real.classList.remove('kvp-atc-docked');
      real.classList.remove('kvp-atc-return');
      real.style.left = '';
      real.style.width = '';
      real.style.bottom = '';
      slot.style.display = 'none';
    }

    function measureSlot() {
      /* While docked the slot is the natural box; while in flow the button is. */
      return (docked ? slot : real).getBoundingClientRect();
    }

    /* Alia renders a full-viewport overlay at the top of the stacking order.
       The docked button sitting over it obscures the offer, so while that
       overlay has content the button stands down and comes back when it
       closes. Hiding rather than restacking: whichever is in front, two things
       fighting over the bottom of a phone screen is the wrong answer. */
    function overlayOpen() {
      var alia = document.querySelector('[id^="alia-root"]');
      if (!alia || !alia.firstElementChild) return false;
      var r = alia.firstElementChild.getBoundingClientRect();
      return r.height > 0 && r.width > 0;
    }

    function update() {
      if (!window.matchMedia(MOBILE).matches) { undock(); return; }
      if (overlayOpen()) { undock(); return; }

      var r = measureSlot();
      if (r.width === 0 && r.height === 0) return;      /* hidden or detached */

      var restBottom = window.innerHeight - GAP;
      /* Dock whenever the button's own place is not sitting comfortably on
         screen: either still below the fold, or already scrolled past. */
      var past = r.top < 0;
      var needsDock = r.bottom > restBottom || past;

      if (needsDock) {
        var h = docked ? slot.offsetHeight : real.offsetHeight;
        var left = Math.round(r.left);
        var width = Math.round(r.width);

        if (!docked) {
          var cs = getComputedStyle(real);
          slot.style.display = 'block';
          slot.style.height = h + 'px';
          slot.style.marginTop = cs.marginTop;
          slot.style.marginBottom = cs.marginBottom;
          docked = true;
          real.classList.toggle('kvp-atc-return', past);
          real.classList.add('kvp-atc-docked');
        }
        real.style.left = left + 'px';
        real.style.width = width + 'px';
        /* Clear of the home indicator on notched phones. */
        real.style.bottom = 'calc(' + GAP + 'px + env(safe-area-inset-bottom, 0px))';
      } else {
        undock();
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    document.addEventListener('scroll', update, { passive: true, capture: true });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('orientationchange', update, { passive: true });
    document.addEventListener('touchmove', update, { passive: true });
    document.addEventListener('change', update, true);
    /* The page is scrolled by a container, so a scroll event can be missed;
       a light poll means the state can never get stuck. */
    setInterval(update, 150);
    update();

    /* A variant change re-renders the buy column and replaces the button. */
    var host = real.closest('.product__info-wrapper') || document.body;
    new MutationObserver(function () {
      if (real.isConnected) return;
      var fresh = document.querySelector('form[action*="/cart/add"] button[type=submit], form[action*="/cart/add"] [name="add"]');
      if (!fresh) return;
      docked = false;
      real = fresh;
      if (!slot.isConnected) real.parentNode.insertBefore(slot, real);
      slot.style.display = 'none';
      update();
    }).observe(host, { childList: true, subtree: true });
  }

  function boot(n) {
    if (document.querySelector('form[action*="/cart/add"] button[type=submit], form[action*="/cart/add"] [name="add"]')) { init(); return; }
    if (n < 25) setTimeout(function () { boot(n + 1); }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); });
  else boot(0);
})();
